import React from 'react';
import { Reveal } from './ui/Reveal';
import { pains } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="familiar" className="border-y border-gold/40 bg-ivory" data-id="element-125" data-mp="2ltmhrt8r1rll">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-8" data-id="element-126" data-mp="30hzfaunhjii7">
        <Reveal className="text-center" data-id="element-127" data-mp="2vq7p4l88resl">
          <h2 id="familiar" className="font-display text-lg font-black uppercase leading-tight text-navy sm:text-2xl lg:text-3xl" data-id="element-128" data-mp="2vp6c4b7o0i88">
            ¿Te suena familiar?
          </h2>
          <p className="mt-1 text-[0.8rem] font-bold text-royal sm:text-[0.95rem]" data-id="element-129" data-mp="35idf5pexnm55">
            Quieres aprender inglés, pero no sabes por dónde empezar.
          </p>
          <p className="mx-auto mt-1 max-w-2xl text-[0.75rem] leading-snug text-navy sm:text-[0.85rem]" data-id="element-130" data-mp="3eia9a6k3dd7l">
            Si estás comenzando desde cero, probablemente conozcas alguna de
            estas situaciones:
          </p>
        </Reveal>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2 lg:grid-cols-4" data-id="element-131" data-mp="jd3nknzxobrf">
          {pains.map((pain, i) => <Reveal key={pain.title} as="li" delay={i * 0.03} className="flex h-full flex-col rounded-lg border border-navy/10 bg-white p-3" data-id="element-132" data-mp="obyfcffvpano" data-mpi={i}>
              <span aria-hidden="true" className="text-xl" data-id="element-133" data-mp="x51qui6yrdfo">
                {pain.icon}
              </span>
              <h3 className="mt-1 font-sans text-[0.78rem] font-extrabold uppercase leading-tight text-navy sm:text-[0.85rem]" data-id="element-134" data-mp="124e9eqqsxycg">
                {pain.title}
              </h3>
              <p className="mt-1 text-[0.73rem] leading-snug text-navy sm:text-[0.8rem]" data-id="element-135" data-mp="1c227nqnm9nzd">
                {pain.desc}
              </p>
            </Reveal>)}
        </ul>
      </div>
    </section>;
}